import React, { useState, useRef, useEffect } from "react";
import "./teamEmailSetupContent.css";
import { Form as BootstrapForm, Row, Col, Button, Alert } from "react-bootstrap";
import { message, Modal, Input, Form } from "antd";
import inputs from '../../hooks/hook.module.css';
import message_zeitro from './custom_message';

const { TextArea } = Input;

export default function TeamEmailSetupContent({ onClose }) {
  const [selectedProvider, setSelectedProvider] = useState("google");
  const [submitted, setSubmitted] = useState(false);
  const [bConfigs, setBConfigs] = useState('');
  const [clientID, setClientID] = useState('');
  const [secret, setSecret] = useState('');
  const [tenantID, setTenantID] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const configRef = useRef();
  const [selectedFileName, setSelectedFileName] = useState('');
  const fileInputRef = useRef();
  const [isHelpModalOpen, setIsHelpModalOpen] = useState(false);
  const [messageReceivedModalOpen, setMessageReceivedModalOpen] = useState(false);
  const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);
  
  // 添加缺失的变量定义
  const [form] = Form.useForm();
  const [currentInfo, setCurrentInfo] = useState({
    email: '',
    plan: ''
  });
  
  // 添加历史配置状态
  const [historicalConfig, setHistoricalConfig] = useState({
    provider: '',
    bConfigs: '',
    clientID: '',
    secret: '',
    tenantID: ''
  });

  // 添加表单验证消息
  const validateMessages = {
    required: '${label} is required!',
    types: {
      email: '${label} is not a valid email!',
    },
  };

  // 添加表单验证状态
  const [clientIDIsValid, setClientIDIsValid] = useState(true);
  const [secretIsValid, setSecretIsValid] = useState(true);
  const [tenantIDIsValid, setTenantIDIsValid] = useState(true);

  // 计算 CSS 类
  const clientIDClasses = `${inputs['form-group']} ${!clientIDIsValid && submitted ? inputs['invalid-input'] : ''}`;
  const secretClasses = `${inputs['form-group']} ${!secretIsValid && submitted ? inputs['invalid-input'] : ''}`;
  const tenantIDClasses = `${inputs['form-group']} ${!tenantIDIsValid && submitted ? inputs['invalid-input'] : ''}`;

  // 检查当前配置是否与历史配置不同
  const hasConfigurationChanged = () => {
    if (selectedProvider !== historicalConfig.provider) {
      return true;
    }
    
    if (selectedProvider === 'google') {
      return bConfigs !== historicalConfig.bConfigs;
    } else if (selectedProvider === 'microsoft') {
      return clientID.trim() !== historicalConfig.clientID ||
             secret.trim() !== historicalConfig.secret ||
             tenantID.trim() !== historicalConfig.tenantID;
    }
    
    return false;
  };

  // 检查是否有历史配置
  const hasHistoricalConfig = () => {
    return historicalConfig.provider !== '';
  };

  const clientIDChangeHandler = (event) => {
    // 去除首尾空格
    const trimmedValue = event.target.value.trim();
    setClientID(trimmedValue);
    setClientIDIsValid(true);
  };

  const clientIDBlurHandler = () => {
    // 去除首尾空格并验证
    const trimmedValue = clientID.trim();
    setClientID(trimmedValue);
    if (submitted) {
      setClientIDIsValid(trimmedValue !== '');
    }
  };

  const secretChangeHandler = (event) => {
    // 去除首尾空格
    const trimmedValue = event.target.value.trim();
    setSecret(trimmedValue);
    setSecretIsValid(true);
  };

  const secretBlurHandler = () => {
    // 去除首尾空格并验证
    const trimmedValue = secret.trim();
    setSecret(trimmedValue);
    if (submitted) {
      setSecretIsValid(trimmedValue !== '');
    }
  };

  const tenantIDChangeHandler = (event) => {
    // 去除首尾空格
    const trimmedValue = event.target.value.trim();
    setTenantID(trimmedValue);
    setTenantIDIsValid(true);
  };

  const tenantIDBlurHandler = () => {
    // 去除首尾空格并验证
    const trimmedValue = tenantID.trim();
    setTenantID(trimmedValue);
    if (submitted) {
      setTenantIDIsValid(trimmedValue !== '');
    }
  };

  const configUploadHandler = (event) => {
    if (event.target.files[0]) {
      const file = event.target.files[0];
      setSelectedFileName(file.name);
      let reader = new FileReader();
      let base64String;

      reader.onload = function () {
        // console.log(reader.result, "reader.result");
        base64String = reader.result.replace("data:", "").replace(/^.+,/, "");
        // console.log(base64String, "base64String");
        setBConfigs(base64String);
      }
      reader.readAsDataURL(file);
    }
  };

  const handleFileButtonClick = () => {
    fileInputRef.current.click();
  };

  const downloadFile = () => {
    const link = document.createElement('a');
    
    // 检查 bConfigs 的格式并相应处理
    let base64Data = bConfigs;
    
    // 如果 bConfigs 已经是完整的 data URL，直接使用
    if (bConfigs.startsWith('data:')) {
      link.href = bConfigs;
    } else {
      // 如果 bConfigs 是纯 base64 字符串，添加正确的 MIME 类型
      link.href = `data:application/json;base64,${bConfigs}`;
    }
    
    link.download = selectedFileName;
    link.click();
  };

  const handleSubmit = () => {
    if(selectedProvider === "google" && (!bConfigs || !hasConfigurationChanged())) {
      // setErrorMessage('Please upload the configuration file');
      return;
    }
    if (selectedProvider === "microsoft" && (!tenantID.trim() || !clientID.trim() || !secret.trim() || !hasConfigurationChanged())) {
      // setErrorMessage('Please fill in all required fields');
      return;
    }
    setIsConfirmModalOpen(true);
  };

  const handleConfirmSubmit = () => {
    if(selectedProvider === "google" && !bConfigs) {
      setErrorMessage('Please upload the configuration file');
      return;
    }
    if (selectedProvider === "microsoft" && (!tenantID.trim() || !clientID.trim() || !secret.trim())) {
      setErrorMessage('Please fill in all required fields');
      return;
    }
    setSubmitted(true);
    setErrorMessage('');

    // 验证 Microsoft 配置
    if (selectedProvider === 'microsoft') {
      const isClientIDValid = clientID.trim() !== '';
      const isSecretValid = secret.trim() !== '';
      const isTenantIDValid = tenantID.trim() !== '';

      setClientIDIsValid(isClientIDValid);
      setSecretIsValid(isSecretValid);
      setTenantIDIsValid(isTenantIDValid);

      if (!isClientIDValid || !isSecretValid || !isTenantIDValid) {
        setErrorMessage('Please fill in all required fields');
        return;
      }
    }

    // 验证 Google 配置
    if (selectedProvider === 'google' && !bConfigs) {
      setErrorMessage('Please upload the configuration file');
      return;
    }

    const token = sessionStorage.getItem("ZeitroA");
    const body = JSON.stringify({
      EmailProvider: selectedProvider === 'microsoft' ? 'Outlook' : 'Gmail',
      Keys: bConfigs,
      ClientID: clientID.trim(),
      Secret: secret.trim(),
      TenantID: tenantID.trim(),
    });

    fetch('/los/updateemailconfigs', {
      method: 'POST',
      headers: {
        Authorization: "Bearer " + token,
        Cache: "no-cache",
        'Content-Type': 'application/json'
      },
      body,
    }).then(response => {
      if (!response.ok) {
        throw new Error(`Error: ${response.statusText}`);
      }
      return response.json();
    }).then(data => {
      if(data.Status !== "Error") {
        // alert("Email configuration updated successfully");
        message_zeitro.success('Email configuration updated successfully');
        if (onClose) {
          onClose();
        }
      } else {
        message_zeitro.error(data.Text);
        setErrorMessage(data.Text);
      }
    }).catch(error => {
      setErrorMessage(error.message || 'Failed to update email configuration');
    }).finally(() => {
      setSubmitted(false);
      setBConfigs('');
      setClientID('');
      setSecret('');
      setTenantID('');
      if (configRef.current) {
        configRef.current.value = '';
      }
      setIsConfirmModalOpen(false);
    });
  };

  const microsoft_content = () => {
    return (
      <>
      <div className="setup-guide">
        {/* <!-- Microsoft 365 Section --> */}
        <div className="platform-section microsoft">
          <div className="platform-title">
            Microsoft 365 (Exchange Online) – App-Only Authentication
          </div>

          <div className="description">Google Workspace (Gmail) – Creating a Service Account with Domain-Wide Delegation</div>

          <div className="step">
            <div className="step-title">1. Access Azure Portal</div>
            <ul className="step-content">
              <li className="instruction">Navigate to the <span className="link">Azure Portal</span></li>
            </ul>
          </div>

          <div className="step">
            <div className="step-title">2. Register a New Application</div>
            <ul className="step-content">
              <li className="instruction">
                Go to <span className="ui-text textBold">"Azure Active Directory"</span> &gt;{" "}
                <span className="ui-text textBold">"App registrations"</span>
              </li>
              <li className="instruction">
                Click <span className="button textBold">"New registration"</span>
              </li>
              <li className="instruction">Enter a name for your application</li>
              <li className="instruction">
                Choose supported account types{" "}
                <em className="example">
                  (e.g., "Accounts in this organizational directory only")
                </em>
              </li>
              <li className="instruction">
                Click <span className="button textBold">"Register"</span>
              </li>
            </ul>
          </div>

          <div className="step">
            <div className="step-title">3. Configure API Permissions</div>
            <ul className="step-content">
              <li className="instruction">
                In the application overview page, go to{" "}
                <span className="ui-text textBold">"API Permissions"</span>
              </li>
              <li className="instruction">
                Click <span className="button textBold">"Add a permission"</span> &gt;{" "}
                <span className="ui-text textBold">"Microsoft Graph"</span> &gt;{" "}
                <span className="ui-text textBold">"Application permissions"</span>
              </li>
              <li className="instruction">
                Select required permissions{" "}
                <em className="example">(e.g., Mail.Send)</em>
              </li>
              <li className="instruction">
                Click <span className="button textBold">"Add permissions"</span>
              </li>
              <li className="instruction">
                Click{" "}
                <span className="button textBold">
                  "Grant admin consent for [Your Organization]"
                </span>{" "}
                and confirm
              </li>
            </ul>
          </div>

          <div className="step">
            <div className="step-title">4. Create a Client Secret</div>
            <ul className="step-content">
              <li className="instruction">
                Navigate to{" "}
                <span className="ui-text textBold">"Certificates & secrets"</span>
              </li>
              <li className="instruction">
                Click <span className="button textBold">"New client secret"</span>
              </li>
              <li className="instruction">
                Enter a description and set expiration
              </li>
              <li className="instruction">
                Click <span className="button textBold">"Add"</span>
              </li>
              <li className="instruction important">
                Copy and securely store the client secret value
              </li>
            </ul>
          </div>

          <div className="step">
            <div className="step-title">5. Note Application Credentials</div>
            <ul className="step-content">
              <li className="instruction">
                Record the <span className="code textBold">"Application (client) ID"</span>{" "}
                and <span className="code textBold">"Directory (tenant) ID"</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div className="description-bottom">Once your Microsoft 365 account is ready, enter the following:</div>
        <div style={{display: 'flex', flexDirection: 'row', gap: '20px', marginBottom: '20px', borderBottom: '1px solid #DDD', width: '100%'}}>
          {/* <Col xs={12} md> */}
            <BootstrapForm.Group controlId="clientID" className={clientIDClasses} style={{flex: 1}}>
              <BootstrapForm.Label><div className="form-label-title">Client ID</div></BootstrapForm.Label>
              <BootstrapForm.Control
                type="text"
                value={clientID}
                onChange={clientIDChangeHandler}
                onBlur={clientIDBlurHandler}
                placeholder="Client ID"
              />
              {/* <Form.Text className="text-muted mb-3">Copy the client id from Azure portal here</Form.Text> */}
            </BootstrapForm.Group>
          {/* </Col>
          <Col xs={12} md> */}
            <BootstrapForm.Group controlId="secretValue" className={secretClasses} style={{flex: 1}}>
              <BootstrapForm.Label><div className="form-label-title">Client credentials (Secret value) </div></BootstrapForm.Label>
              <BootstrapForm.Control
                type="text"
                value={secret}
                onChange={secretChangeHandler}
                onBlur={secretBlurHandler}
                placeholder="Secret Value"
              />
              {/* <Form.Text className="text-muted mb-3">Copy the secret value from Azure portal here</Form.Text> */}
            </BootstrapForm.Group>
          {/* </Col>
          <Col xs={12} md> */}
            <BootstrapForm.Group controlId="tenantID" className={tenantIDClasses} style={{flex: 1}}>
              <BootstrapForm.Label><div className="form-label-title">Directory (Tenant ID)</div></BootstrapForm.Label>
              <BootstrapForm.Control
                type="text"
                value={tenantID}
                onChange={tenantIDChangeHandler}
                onBlur={tenantIDBlurHandler}
                placeholder="Tenant ID"
              />
              {/* <Form.Text className="text-muted mb-3">Copy the tenant id from Azure portal here</Form.Text> */}
            </BootstrapForm.Group>
          {/* </Col> */}
        </div>
        <div className="mt-3" style={{width: '100%', display: 'flex', justifyContent: 'space-between'}}>
          <div className="help-text">
            Need help? 
            <span className="blue-text" style={{ cursor: "pointer", marginLeft: '10px' }} onClick={() => {
              setIsHelpModalOpen(true);
            }}>Contact us</span>
          </div>
          <div>
            <div className={`btn-submit-email ${tenantID.trim() && clientID.trim() && secret.trim() && (!hasHistoricalConfig() || hasConfigurationChanged()) ? 'btn-submit-email-active' : 'btn-submit-email-disabled'}`} onClick={handleSubmit}>
              Submit
            </div>
          </div>
        </div>
      </>
    );
  };

  function onFinish(val) {
    let token = sessionStorage.getItem("ZeitroA")
    fetch('/los/customersupporttoslack', {
        method: 'POST',
        headers: {
            Authorization: "Bearer " + token,
            Cache: "no-cache",
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            Message: val.message
        })
    }).then(async response => {
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
    }).catch(error => {
        console.error('Error sending support message:', error);
        message.error('Failed to send message. Please try again.');
    }).finally(() => {
        setIsHelpModalOpen(false);
        setMessageReceivedModalOpen(true);
    });
  }


  const getOldEmailConfig = () => {
    fetch('/los/getEmailConfigDetails', {
      method: 'GET',
      headers: {
        Authorization: "Bearer " + sessionStorage.getItem("ZeitroA"),
        Cache: "no-cache",
        'Content-Type': 'application/json'
      },
    }).then(response => {
      if (!response.ok) {
        message.error(`Error: ${response.statusText}`);
      }
      response.json().then(res => {
        const data = res.data;
        // console.log(data);
        if(data.Email.Provider === "Gmail"){
          setSelectedProvider("google");
          const base64Config = data?.Email?.Keys?.GmailAPIKey || '';
          // 直接使用 base64 字符串，不需要解码
          setBConfigs(base64Config);
          setSelectedFileName("Gmail.json");
          
          // 保存历史配置
          setHistoricalConfig({
            provider: 'google',
            bConfigs: base64Config,
            clientID: '',
            secret: '',
            tenantID: ''
          });
        } else if(data.Email.Provider === "Outlook") {
          setSelectedProvider("microsoft");
          setBConfigs("");
          const clientIDValue = data?.Email?.Keys?.ClientID || '';
          const secretValue = data?.Email?.Keys?.SecretValue || '';
          const tenantIDValue = data?.Email?.Keys?.TenantID || '';
          
          setClientID(clientIDValue);
          setSecret(secretValue);
          setTenantID(tenantIDValue);
          
          // 保存历史配置
          setHistoricalConfig({
            provider: 'microsoft',
            bConfigs: '',
            clientID: clientIDValue,
            secret: secretValue,
            tenantID: tenantIDValue
          });
        }
      });
    })
  } 

  useEffect(() => {
    getOldEmailConfig();
  }, []);

  const google_content = () => {
    return (
      <>
      <div className="setup-guide">
        {/* <!-- Google Workspace Section --> */}
        <div className="platform-section google">
          <div className="platform-title">To create a service account in Google workspace:</div>
          <div className="description">
          Google Workspace (Gmail) – Creating a Service Account with Domain-Wide Delegation
          </div>
          <div className="step">
            <div className="step-title">1. Access Google Cloud Console:</div>
            <ul className="step-content">
              <li className="instruction">Navigate to <span className="link">Google Cloud Console</span></li>
            </ul>
          </div>
          <div className="step">
            <div className="step-title">2. Create a New Project:</div>
            <ul className="step-content">
              <li className="instruction">Click on the project dropdown and select <span className="button textBold">"New Project"</span>.</li>
              <li className="instruction">Enter a project name and click <span className="button textBold">"Create"</span>.</li>
            </ul>
          </div>
          <div className="step">
            <div className="step-title">3. Enable Gmail API:</div>
            <ul className="step-content">
              <li className="instruction">In the left sidebar, go to <span className="button textBold">"APIs & Services"</span> &gt; <span className="button textBold">"Library"</span>.</li>
              <li className="instruction">Search for <span className="button textBold">"Gmail API"</span> and click on it.</li>
              <li className="instruction">Click <span className="button textBold">"Enable"</span> to activate the API for your project.</li>
            </ul>
          </div>
          <div className="step">
            <div className="step-title">4. Create a Service Account:</div>
            <ul className="step-content">
              <li className="instruction">Navigate to <span className="button textBold">"IAM & Admin"</span> &gt; <span className="button textBold">"Service Accounts"</span>.</li>
              <li className="instruction">Click <span className="button textBold">"Create Service Account"</span>.</li>
              <li className="instruction">Enter a name and description for the service account.</li>
              <li className="instruction">Click <span className="button textBold">"Create and Continue"</span>.</li>
            </ul>
          </div>
          <div className="step">
            <div className="step-title">5. Assign Roles to the Service Account:</div>
            <ul className="step-content">
              <li className="instruction">Assign the <span className="textBold">"Project &gt; Editor"</span> role or a more restrictive role as needed.</li>
              <li className="instruction">Click <span className="button textBold">"Continue"</span> and then <span className="button textBold">"Done"</span>.</li>
            </ul>
          </div>
          <div className="step">
            <div className="step-title">6. Enable Domain-Wide Delegation:</div>
            <ul className="step-content">
              <li className="instruction">Click on the created service account to open its details.</li>
              <li className="instruction">Under the "Details" tab, click "Show Domain-Wide Delegation".</li>
              <li className="instruction">Check the box to "Enable G Suite Domain-wide Delegation".</li>
              <li className="instruction">Note the "Client ID" displayed; you'll need it later.</li>
            </ul>
          </div>
          <div className="step">
            <div className="step-title">7. Create and Download a Private Key:</div>
            <ul className="step-content">
              <li className="instruction">In the service account details, go to the <span className="textBold">"Keys"</span> tab.</li>
              <li className="instruction">Click <span className="textBold">"Add Key"</span> &gt; <span className="textBold">"Create New Key"</span>.</li>
              <li className="instruction">Choose the JSON key type and click <span className="textBold">"Create"</span>.</li>
              <li className="instruction">A JSON file will be downloaded; store it securely as it contains sensitive information</li>
            </ul>
          </div>
          <div className="step">
            <div className="step-title">8. Authorize the Service Account in the Admin Console:</div>
            <ul className="step-content">
              <li className="instruction">Go to the Google Admin Console.</li>
              <li className="instruction">Navigate to <span className="textBold">"Security"</span> &gt; <span className="textBold">"API Controls"</span> &gt; <span className="textBold">"Manage Domain-Wide Delegation"</span>.</li>
              <li className="instruction">Click <span className="textBold">"Add New"</span>.</li>
              <li className="instruction">Enter the <span className="textBold">"Client ID"</span> noted earlier.</li>
              <li className="instruction">In the <span className="textBold">"OAuth Scopes"</span> field, enter the required scopes (e.g., https://www.googleapis.com/auth/gmail.send).</li>
              <li className="instruction">Click <span className="textBold">"Authorize"</span>.</li>
            </ul>
          </div>

        </div>
      </div>
      <div className="description-bottom">Once your Google Workspace account is ready, upload the JSON file you downloaded:</div>
        <BootstrapForm.Group controlId="JSONconfig" className={bConfigs === '' && submitted ? `${inputs['invalid-input']} mb-3` : 'mb-3'}>
          <input
            type="file"
            ref={fileInputRef}
            onChange={configUploadHandler}
            style={{ display: 'none' }}
          />
          <div 
            style={{display: 'flex', alignItems: 'center', gap: '10px',}}
          >
            <div  
              onClick={handleFileButtonClick}           
              style={{ 
                width: 120,
                display: 'flex', 
                alignItems: 'center', 
                gap: '10px',
                marginLeft: '10px',
                color: '#325CEB',
                border: '1px solid #325CEB',
                borderRadius: '6px',
                padding: '10px 16px',
                cursor: 'pointer',
                fontSize: '16px',
                fontWeight: '500',
                background: "#f7f8ff",
              }}>
              <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
                <path d="M3.28094 14.7258C3.28094 14.2114 2.85428 13.7944 2.32797 13.7944C1.80166 13.7944 1.375 14.2114 1.375 14.7258H3.28094ZM20.625 14.7258C20.625 14.2114 20.1983 13.7944 19.672 13.7944C19.1457 13.7944 18.7191 14.2114 18.7191 14.7258H20.625ZM11.7514 2.87936C12.0751 2.47374 12.0011 1.88843 11.5861 1.57204C11.1712 1.25565 10.5723 1.328 10.2486 1.73362L11.7514 2.87936ZM5.29313 7.94329C4.96944 8.3489 5.04345 8.93419 5.45845 9.25063C5.87344 9.56695 6.47227 9.49467 6.79598 9.08906L5.29313 7.94329ZM11.7514 1.73362C11.4277 1.328 10.8288 1.25565 10.4139 1.57204C9.99887 1.88843 9.92492 2.47374 10.2486 2.87936L11.7514 1.73362ZM15.204 9.08906C15.5278 9.49467 16.1266 9.56695 16.5416 9.25063C16.9566 8.93419 17.0305 8.3489 16.7069 7.94329L15.204 9.08906ZM11.953 2.30649C11.953 1.79207 11.5263 1.37504 11 1.37504C10.4737 1.37504 10.047 1.79207 10.047 2.30649H11.953ZM10.047 15.9678C10.047 16.4822 10.4737 16.8992 11 16.8992C11.5263 16.8992 11.953 16.4822 11.953 15.9678H10.047ZM1.375 14.7258V15.9678H3.28094V14.7258H1.375ZM1.375 15.9678C1.375 18.5176 3.44303 20.625 6.04455 20.625V18.7621C4.54086 18.7621 3.28094 17.5335 3.28094 15.9678H1.375ZM6.04455 20.625H15.9554V18.7621H6.04455V20.625ZM15.9554 20.625C18.5569 20.625 20.625 18.5176 20.625 15.9678H18.7191C18.7191 17.5335 17.4591 18.7621 15.9554 18.7621V20.625ZM20.625 15.9678V14.7258H18.7191V15.9678H20.625ZM10.2486 1.73362L5.29313 7.94329L6.79598 9.08906L11.7514 2.87936L10.2486 1.73362ZM10.2486 2.87936L15.204 9.08906L16.7069 7.94329L11.7514 1.73362L10.2486 2.87936ZM10.047 2.30649V15.9678H11.953V2.30649H10.047Z" fill="#325CEB"/>
              </svg>
              <div>
                Upload
              </div>
            </div>
            {selectedFileName && (
              <div 
              style={{display: 'flex', alignItems: 'center', gap: '12px', cursor: 'pointer', padding: '10px 15px', borderRadius: '6px', border: '1px solid #dbdcde', background: '#fcfcfc', borderRadius: '6px' }}
              onClick={downloadFile}
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <rect x="1" y="1" width="22" height="22" rx="3" fill="#1630AC"/>
                  <path d="M22 8.5V16.5H20.4848L18.9697 11.7V16.5H17.4545V8.5H18.9697L20.4848 13.3V8.5H22Z" fill="white"/>
                  <path d="M15.586 16.5H13.5655C13.2308 16.4996 12.9099 16.359 12.6732 16.1091C12.4365 15.8591 12.3034 15.5203 12.303 15.1668V9.8332C12.3034 9.47974 12.4365 9.14087 12.6732 8.89093C12.9099 8.64099 13.2308 8.5004 13.5655 8.5H15.586C15.9207 8.5004 16.2416 8.64099 16.4783 8.89093C16.715 9.14087 16.8481 9.47974 16.8485 9.8332V15.1668C16.8481 15.5203 16.715 15.8591 16.4783 16.1091C16.2416 16.359 15.9207 16.4996 15.586 16.5ZM13.8182 14.9H15.3333V10.1H13.8182V14.9Z" fill="white"/>
                  <path d="M10.4345 16.5H7.15152V14.9H10.1818V13.3H8.66667C8.26495 13.2996 7.8798 13.1309 7.59574 12.8309C7.31168 12.5309 7.15192 12.1242 7.15152 11.7V9.8332C7.1519 9.47974 7.28503 9.14087 7.52171 8.89093C7.7584 8.64099 8.0793 8.5004 8.41402 8.5H11.697V10.1H8.66667V11.7H10.1818C10.5835 11.7004 10.9687 11.8691 11.2527 12.1691C11.5368 12.4691 11.6966 12.8758 11.697 13.3V15.1668C11.6966 15.5203 11.5635 15.8591 11.3268 16.1091C11.0901 16.359 10.7692 16.4996 10.4345 16.5Z" fill="white"/>
                  <path d="M5.28295 16.5H3.2625C2.92778 16.4996 2.60688 16.359 2.3702 16.1091C2.13352 15.8591 2.00038 15.5203 2 15.1668V13.3H3.51515V14.9H5.0303V8.5H6.54545V15.1668C6.54507 15.5203 6.41194 15.8591 6.17526 16.1091C5.93857 16.359 5.61767 16.4996 5.28295 16.5Z" fill="white"/>
                </svg>
                <span style={{ color: '#000', fontSize: '16px', fontWeight: '500' }} >{selectedFileName}</span>
              </div>
            )}
          </div>
        </BootstrapForm.Group>
        <div style={{width: '100%', height: '1px', backgroundColor: '#DDD', marginBottom: '20px'}}></div>
        <div className="mt-3" style={{width: '100%', display: 'flex', justifyContent: 'space-between'}}>
          <div className="help-text">
            Need help? 
            <span className="blue-text" style={{ cursor: "pointer", marginLeft: '10px' }} onClick={() => {
              setIsHelpModalOpen(true);
            }}>Contact us</span>
          </div>
          <div>
            <div className={`btn-submit-email ${bConfigs && (!hasHistoricalConfig() || hasConfigurationChanged()) ? 'btn-submit-email-active' : 'btn-submit-email-disabled'}`} onClick={handleSubmit}>
              Submit
            </div>
          </div>
        </div>
      </>
    )
  }

  return (
    <div className="team-email-setup-content">
      <div className="tips">
        This integration will allow each team member to send from their own
        address (e.g. jane@zeitro.com)
      </div>
      <div className="select-email-provider">
        <div className="select-email-provider-title">
          Select your email provider
        </div>
        <div className="select-email-provider-box">
          <div
            className={`select-email-provider-box-item ${
              selectedProvider === "google" ? "active" : "deactive"
            }`}
            onClick={() => setSelectedProvider("google")}
          >
            <img src={"/images/google-logo.png"} alt="google" />
            <div className="select-email-provider-box-item-title">Google</div>
          </div>
          <div
            className={`select-email-provider-box-item ${
              selectedProvider === "microsoft" ? "active" : "deactive"
            }`}
            onClick={() => setSelectedProvider("microsoft")}
          >
            <img src={"/images/microsoft-logo.png"} alt="microsoft" />
            <div className="select-email-provider-box-item-title">
              Microsoft
            </div>
          </div>
        </div>
        <div className="description">
          *Only Google Workspace and Microsoft work accounts are supported. For
          other email provider please use{" "}
          <span className="blue-text" style={{ cursor: "pointer" }} onClick={() => {
            onClose && onClose();
          }}>individual email setup.</span>
        </div>
      </div>
      <div className="team-email-setup-content-box">
        {selectedProvider === "google" && <div style={{width: '100%'}}>{google_content()}</div>}
        {selectedProvider === "microsoft" && <div style={{width: '100%'}}>{microsoft_content()}</div>}
      </div>
      {/* {errorMessage && (
        <Alert variant="danger" className="mt-3">
          {errorMessage}
        </Alert> 
      )} */}

      <Modal 
        width={500}
        open={isConfirmModalOpen} 
        footer={null} 
        className='team-email-setup-confirm-modal'
        onCancel={() => {
            setIsConfirmModalOpen(false)
        }}>
        <div className=''>
            <div className='User_modal_title' style={{fontSize: '18px', fontWeight: '500', color: '#222', display: 'flex', alignItems: 'center', gap: '8px', padding: '20px 24px 12px', borderBottom: '1px solid #ECECEC'}}>
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                <rect width="18" height="18" rx="9" fill="#081265"/>
                <rect x="8" y="4" width="2" height="7" rx="1" fill="white"/>
                <rect x="10" y="12" width="2" height="2" rx="1" transform="rotate(90 10 12)" fill="white"/>
              </svg>
              <div>Replace existing integration?</div>
            </div>
            <div className='' style={{fontSize: '16px', fontWeight: '400', lineHeight: '22px', color: '#222', padding:'20px 24px', display: 'flex', flexDirection: 'column', gap: '16px'}}>
              <div>Submitting will update your team's email settings. The current integration will be removed and may stop working right away.</div>
              <div>Are you sure you want to replace it?</div>
            </div>
            <div style={{width: '100%', display: 'flex', justifyContent: 'space-between', padding: '10px 24px 20px'}}>
                <div className="btn-confirm-modal-primary" onClick={() => {
                    setIsConfirmModalOpen(false)
                }}>Cancel</div>
                <div className="btn-confirm-modal-cancel" onClick={handleConfirmSubmit}>Confirm and submit</div>
            </div>
        </div>
      </Modal>

      <Modal 
        width={786}
        className='help-modal-setup'
        open={isHelpModalOpen} 
        footer={null} 
        onCancel={() => {
            setIsHelpModalOpen(false)
        }}>
        <div className='help-modal-content'>
            <div className='help-modal-content-title'>How can we help?</div>
            <div className='help-modal-content-tips'>For inquiries regarding billing, payments, product feedback, or any issues encountered while using Zeitro, we're here to assist you promptly. </div>

            <Form
                className='help-modal-form'
                onFinish={onFinish}
                form={form}
                style={{ marginTop: '20px', }}
                layout='vertical'
                validateMessages={validateMessages}

            >
                <Row>
                    <Col span={24}>
                        <Form.Item
                            className='help-modal-form-item'
                            name="message"
                            label="Message"
                        >
                            <TextArea
                                className='help-modal-form-item-textarea'
                                placeholder="Please leave us a message..." 
                                style={{ 
                                    height: '250px',
                                    resize: 'none'
                                }}
                            />
                        </Form.Item>
                    </Col>
                    <div style={{fontFamily: 'Inter', color: '#6E6E70', width: '100%', textAlign: 'center', marginTop: 20, lineHeight: '20px', letterSpacing: '0.2px'}}>Alternatively, you could also email us at <span style={{color: '#325CEB'}}>support@zeitro.com</span></div>
                </Row>

                <div style={{width: '100%', display: 'flex', justifyContent: 'center', gap: '48px'}}>
                    <div className='btn-confirm-modal-cancel' onClick={() => {
                        setIsHelpModalOpen(false)

                    }}>Cancel</div>
                    <div className='btn-confirm-modal-primary' type='primary' htmlType="submit">Send Message</div>

                </div>
            </Form>
        </div>
      </Modal>

      <Modal open={messageReceivedModalOpen} footer={null} onCancel={() => {
          setMessageReceivedModalOpen(false)
      }}>
          <div className='text-center p-5'>
              <div><img src='/images/emailSent.svg' /></div>
              <div className='User_modal_title my-3'>We've received your message</div>
              <div className='title-5 text-center'>Thank you for reaching out. </div>
              <div className='title-5 text-center'>We will get back to you via email as soon as possible.</div>
              <Button type='primary' size='large' className='mt-4' onClick={() => setMessageReceivedModalOpen(false)}>Done</Button>
          </div>
      </Modal>
    </div>
  );
}
